import { Navigate } from "react-router"
import { useUser } from "../../../context/UserContext"

const PrivateRoute = ({ children }: any) => {
  const { user } = useUser()
  return user.email ? children : <Navigate to="/signin" replace />;

}

export default PrivateRoute
